import { useEffect, useState } from "react";
import { Layout } from "./Modules/layout";
import { LayoutHome } from "./Modules/layout_home";
import LayoutCorporate from "./Modules/layout_corporate";
import { LoginURL } from "./Util/axios_helper";

function App() {
  const [loadCss, setLoadCss] = useState(false);
  const corpRoutes = [
    "/dashboard",
    "/sales",
    "/revenue",
    "/execution",
    "/ringcentral",
    "/countlead",
    "/customersatisfaction",
    "/feedbacklist",
    "/email-configuration",
    "/app-configuration",
    "/banner",
    "/myBallroom",
    "/gallery_main",
    "/testimonials",
    "/welcomesection",
    "/upcomingevents",
    "/highlightsawards",
    "/aboutus",
    "/f-a-q",
    "/privacyterms",
    "/packages",
    "/eventtipspage",
    "/eventtipsimage",
    "/eventtips",
    "/blog",
    "/services",
    "/amenities",
    "/venueHighlights",
    "/vendortypes",
    "/registeredvendor",
    "/rentalhighlights",
    "/facilities",
    "/facilitylist",
    "/videos",
    "/rentalservicedetails",
    "/rentalguideline",
    "/settings",
    "/registeredvendormobile",
    "/rental-categorysanditems",
    "/decorationitem",
    "/vendorRequest",
    "/payment_methods",
    "/decoration",
  ];
  const corpTheme = [
    "/corporate",
    "/design-decor",
    "/rentalguidlinesdetails",
    "/categoriesdetails",
    "/decorationcategorydetails",
    "/rentalitem",
    "/cart",
    "/cartlist",
  ];
  let currentRoute =
    "/" + window.location.pathname.toLowerCase().trim().split("/")[1];

  // let currentRoute = window.location.pathname.toLowerCase().trim();
  const lowerCaseCorpRoutes = corpRoutes?.map((route) => route.toLowerCase());

  useEffect(() => {
    loadResources();
  }, []);

  const loadResources = () => {
    let CorpFlag = false;
    if (currentRoute == "/admin") {
      window.history.replaceState(null, "", window.location.href);
      window.location.href = LoginURL;
      return;
    } else if (lowerCaseCorpRoutes.includes(currentRoute)) {
      CorpFlag = true;
    } else if (corpTheme?.includes(currentRoute)) {
      CorpFlag = true;
    }

    if (!loadCss && !CorpFlag) {
      $("#bannerSection").hide();
      loadUnCorpThemeStyles()
        .then((v) => {
          if (v) {
            LoadJSandCSS(CorpFlag).then(() => {
              setLoadCss(true);
              $("#root").removeClass("hidden");

              setTimeout(() => {
                $("#mloader").fadeOut();
                // $("#bannerSection").fadeIn();
              }, 100);
            });
          }
        })
        .catch((e) => console.error(error));
    } else if (!loadCss && CorpFlag) {
      $("#mloader").show();
      LoadJSandCSS(CorpFlag).then(() => {
        setLoadCss(true);
        $("#root").removeClass("hidden");

        setTimeout(function () {
          // $("#mloader").hide()
          $("#mloader").fadeOut();
        }, 1500);
      });
    }
  };

  if (!loadCss) return null;
  return (
    <div>
      {lowerCaseCorpRoutes?.includes(currentRoute) ? (
        <Layout />
      ) : corpTheme?.includes(currentRoute) ? (
        <LayoutCorporate />
      ) : (
        <LayoutHome />
      )}
    </div>
  );
}

export default App;
